import styled from "styled-components";

export const SelectWrapper = styled.div`
  min-width: auto;
  max-width: 100%;
  margin-top: 8px;

  .ant-select {
    width: ${({ width }) => width || "100%"};
    border-radius: 8px;
  }
  .ant-select-selector {
    height: ${({ height }) => height || "44px"} !important;
    border-radius: 8px !important;
  }
  .ant-select:not(.ant-select-customize-input).ant-select-selector {
    border: ${({ border }) => border || "#dfe1e7"};
  }
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #6610f2;
    border-right-width: 1px;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-color: #6610f2 !important;
    box-shadow: 0 0 2px #8b44ff !important;
    border-radius: 8px !important;
  }

  .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    margin-top: 7px;
    color: black;
  }
`;
